export default {
  creditor: () => import("/codebuild/output/src2789111138/src/melembre-landing-page-v2/layouts/creditor.vue").then(m => m.default || m),
  default: () => import("/codebuild/output/src2789111138/src/melembre-landing-page-v2/layouts/default.vue").then(m => m.default || m)
}